export default {
  hotProducts: [
    {
      serialId: 'FC0002',
      title: '小规模代理记账',
      summary: '在企业湾代理记账，放心无忧',
      img: 'product-SHSHFC0002-cover.jpg',
      price: 168
    },
    {
      serialId: 'LD0023',
      title: '商标注册',
      summary: '商标是企业的敲门砖，让专业律师帮您紧握手中',
      img: 'product-SHSHLD0012-cover-1.jpg',
      price: 899
    },
    {
      serialId: 'HR1001',
      title: '个人五险一金挂靠',
      summary: '个人五险一金挂靠',
      img: 'product-JSSZHR0005-cover.jpg',
      price: 66
    },
    // {
    //   serialId: 'TP0001',
    //   title: '慧优税',
    //   summary: '我们将根据客户实际情况进行专业税务筹划，提供最专业的税收筹划方案，找捷税大师，最低可降低到0.5%，让您收入提升70%以上！',
    //   img: 'product-TP0001-cover.jpg',
    //   price: 6000
    // },
  ],
  regions: [
    {
      name: '上海',
      code: 'SHSH',
      pName: '上海',
      remarks: '上海代理记账公司一般多少钱一个月？中小企业收费标准',
      areas: [
        '黄浦区',
        '卢湾区',
        '徐汇区',
        '长宁区',
        '静安区',
        '普陀区',
        '闸北区',
        '虹口区',
        '杨浦区',
        '闵行区',
        '宝山区',
        '嘉定区',
        '浦东新区',
        '金山区',
        '松江区',
        '青浦区',
        '南汇区',
        '奉贤区',
        '崇明县',
        '城桥镇',
        '临港区'
      ]
    },
    {
      name: '北京',
      code: 'BJBJ',
      pName: '北京',
      remarks: '北京小企业代理记账公司的选择那些',
      areas: [
        '东城区',
        '西城区',
        '崇文区',
        '宣武区',
        '朝阳区',
        '丰台区',
        '石景山区',
        '海淀区',
        '门头沟区',
        '房山区',
        '通州区',
        '顺义区',
        '昌平区',
        '大兴区',
        '怀柔区',
        '平谷区',
        '密云县',
        '延庆县'
      ]
    },
    {
      name: '南京',
      code: 'JSNJ',
      pName: '江苏',
      remarks: '南京注册公司代办、南京注册公司栖霞区代账公司',
      areas: [
        '玄武区',
        '白下区',
        '秦淮区',
        '建邺区',
        '鼓楼区',
        '下关区',
        '浦口区',
        '六合区',
        '栖霞区',
        '雨花台区',
        '江宁区',
        '溧水县',
        '永阳镇',
        '高淳县',
        '淳溪镇'
      ]
    },

    {
      name: '苏州',
      code: 'JSSZ',
      pName: '江苏',
      remarks: '苏州园区代账公司、商标注册有哪些要求',
      areas: [
        '金阊区',
        '沧浪区',
        '平江区',
        '虎丘区',
        '吴中区',
        '相城区',
        '吴江市',
        '昆山市',
        '太仓市',
        '常熟市',
        '张家港市'
      ]
    },
    {
      name: '镇江',
      code: 'JSZJ',
      pName: '江苏',
      remarks: '代理记账公司一般为多少家公司服务',
      areas: [
        '京口区',
        '润州区',
        '丹徒区',
        '扬中市',
        '丹阳市',
        '句容市'
      ]
    },

    {
      name: '深圳',
      code: 'GDSZ',
      pName: '广东',
      remarks: '深圳公司注册代理记账商标注册',
      areas: [
        '福田区',
        '罗湖区',
        '南山区',
        '宝安区',
        '龙岗区',
        '盐田区',
        '光明新区',
        '龙华区'
      ]
    },
    {
      name: '成都',
      code: 'SCCD',
      pName: '四川',
      remarks: '中型企业代理记账多少钱成都',
      areas: [
        '高新区',
        '天府新区',
        '青羊区',
        '锦江区',
        '金牛区',
        '武侯区',
        '成华区',
        '龙泉驿区',
        '温江区',
        '双流县',
        '郫县'
      ]
    },
    {
      name: '合肥',
      code: 'AHHF',
      pName: '安徽',
      remarks: '小企业代账多少钱',
      areas: [
        '肥东县',
        '庐江县',
        '包河区',
        '蜀山区',
        '瑶海区',
        '庐阳区',
        '经济技术开发区',
        '高新技术开发区',
        '北城新区',
        '滨湖新区',
        '政务文化新区',
        '新站综合开发试验区',
        '肥西县',
        '巢湖市',
        '长丰县'
      ]
    },
    {
      name: '郑州',
      code: 'HNZZ',
      pName: '河南',
      remarks: '郑州代账财务公司代理记账的作用是什么',
      areas: [
        '中原区',
        '二七区',
        '管城区',
        '金水区',
        '上街区',
        '惠济区',
        '郑东新区',
        '高新区',
        '经开区',
        '航空港',
        '自贸区'
      ]
    },
    {
      name: '扬州',
      code: 'JSYZ',
      pName: '江苏',
      remarks: '扬州注册公司需要那些条件、多少钱',
      areas: [
        '广陵区',
        '邗江区',
        '江都区',
        '宝应县',
        '仪征市',
        '高邮市'
      ]
    },
    {
      name: '重庆',
      code: 'CQCQ',
      pName: '重庆',
      remarks: '代理记账公司重庆一年需要多少钱',
      areas: [
        '渝中区',
        '江北区',
        '南岸区',
        '九龙坡区',
        '沙坪坝区',
        '渝北区',
        '大渡口区',
        '巴南区',
        '北碚区'
      ]
    },
    {
      name: '无锡',
      code: 'JSWX',
      pName: '江苏',
      remarks: '无锡正规代账公司哪家好，服务项目有什么',
      areas: [
        '崇安区',
        '南长区',
        '滨湖区',
        '惠山区',
        '北塘区',
        '锡山区',
        '宜兴市',
        '江阴市',
        '梁溪区',
        '新吴区'
      ]
    },
    {
      name: '武汉',
      code: 'HBWH',
      pName: '湖北',
      remarks: '武汉哪家代账好专业',
      areas: [
        '江岸区',
        '江汉区',
        '硚口区',
        '汉阳区',
        '武昌区',
        '洪山区',
        '青山区',
        '东西湖区',
        '蔡甸区',
        '江夏区',
        '黄陂区',
        '新洲区',
        '汉南区',
        '东湖高新区'
      ]
    },
    {
      name: '昆山',
      code: 'JSKS',
      pName: '江苏',
      remarks: '如何查询商品注册商标昆山注册公司',
      areas: [
        '玉山镇',
        '巴城镇',
        '周市镇',
        '陆家镇',
        '花桥镇',
        '淀山湖镇',
        '张浦镇',
        '周庄镇',
        '千灯镇',
        '锦溪镇'
      ]
    }
  ],

  companyTypeOptions: [
    {
      id: 1,
      label: '有限责任公司',
      value: '有限责任公司'
    },
    {
      id: 2,
      label: '股份责任公司',
      value: '股份责任公司'
    },
    {
      id: 3,
      label: '有限合伙公司',
      value: '有限合伙公司'
    },
    {
      id: 4,
      label: '外商独资公司',
      value: '外商独资公司'
    },
    {
      id: 5,
      label: '个人独资公司',
      value: '个人独资公司'
    }
  ],
  industryOptions: [
    {
      label: '计算机/互联网/通信/电子',
      value: 1,
      children: [
        {value: 10, label: '计算机软件'},
        {value: 11, label: '计算机硬件'},
        {value: 12, label: '计算机服务(系统、数据服务、维修)'},
        {value: 13, label: '通信/电信/网络设备'},
        {value: 14, label: '通信/电信运营、增值服务'},
        {value: 15, label: '互联网/电子商务'},
        {value: 16, label: '网络游戏'},
        {value: 17, label: '电子技术/半导体/集成电路'},
        {value: 18, label: '仪器仪表/工业自动化'}
      ]
    },
    {
      label: '会计/金融/银行/保险',
      value: 2,
      children: [
        {value: 20, label: '会计/审计'},
        {value: 21, label: '金融/投资/证券'},
        {value: 22, label: '银行'},
        {value: 23, label: '保险'},
        {value: 24, label: '信托/担保/拍卖/典当'},
      ]
    },
    {
      label: '贸易/消费/制造/营运',
      value: 3,
      children: [
        {value: 30, label: '贸易/进出口'},
        {value: 31, label: '批发/零售'},
        {value: 32, label: '快速消费品(食品、饮料、化妆品)'},
        {value: 33, label: '服装/纺织/皮革'},
        {value: 34, label: '家具/家电/玩具/礼品'},
        {value: 35, label: '奢侈品/收藏品/工艺品/珠宝'},
        {value: 36, label: '办公用品及设备'},
        {value: 37, label: '机械/设备/重工'},
        {value: 38, label: '汽车及零配件'},
      ]
    },
    {
      label: '制药/医疗',
      value: 4,
      children: [
        {value: 40, label: '制药/生物工程'},
        {value: 41, label: '医疗/护理/卫生'},
        {value: 42, label: '医疗设备/器械'},
      ]
    },
    {
      label: '广告/媒体',
      value: 5,
      children: [
        {value: 50, label: '广告'},
        {value: 51, label: '公关/市场推广/会展'},
        {value: 52, label: '影视/媒体/艺术/文化传播'},
        {value: 53, label: '文字媒体/出版'},
        {value: 54, label: '印刷/包装/造纸'},
      ]
    },
    {
      label: '房地产/建筑',
      value: 6,
      children: [
        {value: 60, label: '房地产'},
        {value: 61, label: '建筑/建材/工程'},
        {value: 62, label: '家居/室内设计/装潢'},
        {value: 63, label: '物业管理/商业中心'}
      ]
    },
    {
      label: '专业服务/教育/培训',
      value: 7,
      children: [
        {value: 70, label: '中介服务'},
        {value: 71, label: '租赁服务'},
        {value: 72, label: '专业服务(咨询、人力资源、财会)'},
        {value: 73, label: '外包服务'},
        {value: 74, label: '检测，认证'},
        {value: 75, label: '法律'},
        {value: 76, label: '教育/培训/院校'},
        {value: 77, label: '学术/科研'},
      ]
    },
    {
      label: '服务业',
      value: 8,
      children: [
        {value: 80, label: '餐饮业'},
        {value: 81, label: '酒店/旅游'},
        {value: 82, label: '娱乐/休闲/体育'},
        {value: 83, label: '美容/保健'},
        {value: 84, label: '生活服务'},
      ]
    },
    {
      label: '物流/运输',
      value: 9,
      children: [
        {value: 90, label: '交通/运输/物流'},
        {value: 91, label: '航天/航空'}
      ]
    },
    {
      label: '能源/原材料',
      value: 10,
      children: [
        {value: 100, label: '石油/化工/矿产/地质'},
        {value: 101, label: '采掘业/冶炼'},
        {value: 102, label: '电气/电力/水利'},
        {value: 103, label: '新能源'},
        {value: 104, label: '电气/电力/原材料和加工水利'},
      ]
    },
    {
      label: '政府/非盈利机构/其他',
      value: 11,
      children: [
        {value: 110, label: '政府/公共事业'},
        {value: 111, label: '非盈利机构'},
        {value: 112, label: '环保'},
        {value: 113, label: '农/林/牧/渔'},
        {value: 114, label: '多元化业务集团公司'},
        {value: 115, label: '其他'},
      ]
    }
  ],
  operationStatusOptions: [
    {
      "label":"存续", "value":"存续"
    },
    {
      "label":"在业", "value":"在业"
    },
    {
      "label":"吊销", "value":"吊销"
    },
    {
      "label":"注销", "value":"注销"
    },
    {
      "label":"迁入", "value":"迁入"
    },
    {
      "label":"迁出", "value":"迁出"
    },
    {
      "label":"停业", "value":"停业"
    },
    {
      "label":"清算", "value":"清算"
    }
  ],

}



// WEBPACK FOOTER //
// ./src/api/data.js